import { Stack, Theme, useTheme, SxProps } from "@mui/material";

const IconCircleWrapper = ({
  size = 40,
  color,
  bgcolor,
  children,
  sx,
}: {
  size?: number;
  bgcolor?: string;
  color?: string;
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}) => {
  const theme: Theme = useTheme();

  return (
    <Stack
      width={size ?? 40}
      height={size ?? 40}
      borderRadius="50%"
      alignItems="center"
      justifyContent="center"
      bgcolor={bgcolor ?? theme.palette.purple[50]}
      color={color ?? theme.palette.common.white}
      sx={{ aspectRatio: 1, fontSize: size * 0.7, ...sx }}
    >
      {children}
    </Stack>
  );
};

export default IconCircleWrapper;
